;(function(w){
	function Capitulo(data){
		var self = this;
		this.main = $('.chapter[data-url-key="'+data.route_key+'"]')[0];

		var contenidos_btn = $(this.main).find('.icon-plus')[0];
		var cerrar_btn = $(this.main).find('.bt-close')[0];

		$(this.main).find('.hotspot_btn').bind('click', onClickHotspotBtn);

				

		var hammer = new Hammer($(this.main).find('.overlay')[0]);
		hammer.get('swipe').set({direction: Hammer.DIRECTION_ALL})
		hammer.on("swipe", onSwipeOverlay);

		var hammer2 = new Hammer($(this.main).find('.action-buttons')[0]);
		hammer2.get('swipe').set({direction: Hammer.DIRECTION_ALL})
		hammer2.on("swipe", onSwipeOverlay);


		$(contenidos_btn).bind('click', onClickContenidosBtn);
		$(cerrar_btn).bind('click', onClickCerrarBtn);

		function onClickContenidosBtn(e){
			e.preventDefault();

			$(self.main).addClass('menu-open');
		}

		function onClickCerrarBtn(e){
			$(self.main).removeClass('menu-open');
		}

		function onClickHotspotBtn(e){
			e.preventDefault();

			var obj = {};
			obj.titulo = data.titulo;
			obj.contenidos = data.contenidos;

			Main.lightbox_contenido.mostrar($(this).data('contenido-index'), obj);
		
		}

		function onSwipeOverlay(e){
			e.srcEvent.preventDefault();
			e.srcEvent.stopPropagation();
		}

	}
	
	w.Capitulo = Capitulo;
})(window)